import { Card, Flex, Select, Typography } from "antd";
import React, { useState } from "react";

import arrowDown from "../../../../assets/icons/arrow-down.png";
import ProcedureRowItem from "./ProcedureRowItem";

const testTopPerformedProcedures = [
  { procedureCode: 12345, procedureDescription: "Root Canal", patients: 1000 },
  { procedureCode: 12345, procedureDescription: "Root Canal", patients: 900 },
  { procedureCode: 12345, procedureDescription: "Root Canal", patients: 800 },
  { procedureCode: 12345, procedureDescription: "Root Canal", patients: 700 },
  { procedureCode: 12345, procedureDescription: "Root Canal", patients: 600 },
  { procedureCode: 12345, procedureDescription: "Root Canal", patients: 500 },
];

export default function TopPerformedProcedures() {
  const [isArrowDown, setIsArrowDown] = useState(true);

  const topDropdownOptions = [
    { value: 5, label: "Top 5" },
    { value: 10, label: "Top 10" },
    { value: 15, label: "Top 15" },
  ];

  return (
    <Card className="treatment-statistics-first-row">
      <Flex align="center" justify="space-between" style={{ marginBottom: 30 }}>
        <Typography.Title level={4} style={{ marginBottom: 0 }} ellipsis>
          Top Performed Procedures
        </Typography.Title>
        <Select
          options={topDropdownOptions}
          defaultValue={10}
          style={{ width: 104, display: "flex", alignItems: "center", color: "#6b43b5", marginLeft: 10 }}
          suffixIcon={<img src={arrowDown} alt="arrow-down" style={{ width: 16, transform: `rotate(${isArrowDown ? "0" : "180deg"})` }} />}
          className="custom-style-selection-top-performed-procedures"
          onOpenChange={() => setIsArrowDown((down) => !down)}
        />
      </Flex>

      <Flex vertical gap={10} style={{ height: 237, overflowY: "auto" }} className="custom-scroll">
        {testTopPerformedProcedures.map((procedure, index) => (
          <ProcedureRowItem index={index} procedure={procedure} itemCount={procedure.patients} itemCountDescription="Patients" />
        ))}
      </Flex>
    </Card>
  );
}
